import {routerConfig} from "./RouterConfig";
import bulkBadgesController from "./BulkBadgesController";
import adviserController from "./adviser.ctrl";
import scratchSummaryController from "./summary/ScratchSummaryController";
import adviserSummaryCtrl from "./summary/adviserSummary.tpl";

const ModuleName = "tf.adviser";

export default angular.module(ModuleName, [])
                      .config(routerConfig)
                      .controller("bulkBadgesCtrl", bulkBadgesController)
                      .controller("adviserCtrl", adviserController)
                      .controller("scratchSummaryCtrl", scratchSummaryController)
                      .controller("adviserSummaryCtrl", adviserSummaryCtrl)
                      .name;
